import type { Params } from '../index';

export async function validateFormBeforeTokenization(props: Params): Promise<boolean> {
	props.resetErrors();

	await props.beforeToken('creditCard');

	if (!(await props.validate('creditCard'))) {
		return false;
	}
	if (props.prePaymentChecks && !(await props.prePaymentChecks('creditCard'))) {
		/*
			If the replace payment method confirmation modal is declined by the user,
			show no error, do not process the payment
		*/
		return false;
	}
	return true;
}
